export default __webpack_public_path__ + "static/media/code-branch-solid.cab32edf.svg";